import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ProjectBriefLauncher } from './ProjectBriefModal';

export default function ContactForm({ defaultProjectType = '' }) {
  const [form, setForm] = useState({ name: '', email: '', phone: '', projectType: defaultProjectType, message: '' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent' | 'error'

  const set = (field) => (e) => setForm(f => ({ ...f, [field]: e.target.value }));

  const submit = async () => {
    if (!form.name || !form.email || !form.message) {
      setStatus('error');
      return;
    }
    setStatus('sending');
    try {
      const res = await fetch('/mail.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      setStatus(data.ok ? 'sent' : 'error');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'sent') return (
    <div style={{ padding: '3rem', border: '1px solid rgba(141,189,189,0.3)', color: 'white', textAlign: 'center' }}>
      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.8rem', fontWeight: 300, marginBottom: '0.75rem' }}>Message Received</div>
      <p style={{ fontSize: '0.9rem', fontWeight: 300, color: 'rgba(255,255,255,0.6)' }}>We'll be in touch within one business day.</p>
    </div>
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-field">
          <label>Name</label>
          <input type="text" placeholder="Your name" value={form.name} onChange={set('name')} />
        </div>
        <div className="form-field">
          <label>Email</label>
          <input type="email" placeholder="your@email.com" value={form.email} onChange={set('email')} />
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
        <div className="form-field">
          <label>Phone</label>
          <input type="tel" placeholder="(555) 000-0000" value={form.phone} onChange={set('phone')} />
        </div>
        <div className="form-field">
          <label>Project Type</label>
          <select value={form.projectType} onChange={set('projectType')}>
            <option value="">Select a type...</option>
            <option>Repair & Renovation</option>
            <option>Custom Installation / Functional Art</option>
            <option>Structural Work</option>
            <option>Not Sure Yet</option>
          </select>
        </div>
      </div>
      <div className="form-field">
        <label>Message</label>
        <textarea placeholder="Describe your project — location, scope, timeline..." value={form.message} onChange={set('message')} />
      </div>
      {status === 'error' && <p style={{ fontSize: '0.8rem', color: '#e07070' }}>Please fill in name, email, and message.</p>}
      <p style={{ fontSize: '0.75rem', fontWeight: 300, lineHeight: 1.5, color: 'rgba(255,255,255,0.45)' }}>
        By submitting, you acknowledge our <Link to="/terms-and-privacy" style={{ color: 'var(--aqua-light)' }}>Terms &amp; Privacy Notice</Link>.
      </p>
      <button className="btn-gold" onClick={submit} disabled={status === 'sending'}>
        {status === 'sending' ? 'Sending...' : 'Send Message →'}
      </button>
      <ProjectBriefLauncher />
    </div>
  );
}
